/*
 * Copyright (c) Nexign, JSC, 2022-2023.
 */
/**
 *
 * @author Ilya Babanov
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.21.0
 */

const edmDeliveryTags = {
    EDM_OPERATORS: 'edmOperators',
} as const;

const pageAccountInfoTags = {
    ACCOUNT_INFO_DELIVERY_META: 'accountInfoDeliveryMeta',
} as const;

const userNotificationsTags = {
    USER_NOTIFICATIONS_SETTINGS: 'userNotificationsSettings',
    USER_NOTIFICATIONS_LIST: 'userNotificationsList',
} as const;

const newsTags = {
    NEWS_LIST: 'newsList',
} as const;

export { edmDeliveryTags, pageAccountInfoTags, userNotificationsTags, newsTags };
